var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('picture',{staticClass:"picture-element"},[(!_setup.isPng)?[_c('source',{attrs:{"type":"image/avif","srcset":_setup.avifImageUrl}}),_c('source',{attrs:{"type":"image/webp","srcset":_setup.webpImageUrl}})]:_vm._e(),_c('img',{staticClass:"provider-icon",class:[
			{
				wide: _setup.isWideIcon,
				square: !_setup.isWideIcon,
			},
			_vm.size,
		],attrs:{"loading":_vm.lazy ? 'lazy' : 'eager',"alt":_setup.providerClearName,"title":_setup.providerClearName,"src":_setup.imageUrl},on:{"click":function($event){return _vm.$emit('click')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }